/**
 * App配置信息
 */


export class AppConfig {

  static APP_DEBUG = true;

  // Default values
  static _CDN_: string = 'http://wanshidingdang.b0.upaiyun.com';//图片CDN地址
  static SHARE_LINK: string = 'http://114.55.4.229/sale_info.php?sale_uuid='; // 分享链接
  static NOTIFY_URL: string = 'http://v2.tp13.com/v1/alipay';                 // Alipay
  static CUSTOMER_SERVICE: string = '售后微信：LAB218';                        // 售后微信
  static SETTINGS_KEY: string = '_user_data';
  static REMEMBER_PHONE = '';


  static _defaults: any;
  static _user: any;
  static remembphone: any = '';

  static cartNeedFresh: boolean = false;                //是否有资料变更需要刷新页面
  static consigneeTmp: any;                             //临时选择的收件人
  static orderConsigneeTmp: any;                        //临时选择的地区
  static orderCouponsTmp: any;                          //临时选择的优惠券

  static readonly USER_DEFAULT = {
    avatar: "/avatar/default.gif",
    juser: {
      password: "",
      uid: "",
      username: "",
    },

    nickname: "未登录",
    phone: '',
    profile: {
      bg_image: "/andriod/userbg.jpg",
      birthday: '',
      created_at: '',
      description: '',
      gender: "未知",
      uid: '',
    },
    uid:'',
    username:'',
    token: '',
  }

  static NETWORK_TYPE: string = '';       // unknown, ethernet, wifi, 2g, 3g, 4g, cellular, none
  static IS_ONLINE: number;          // online=1, offline=0
  //


  static PCmodel: boolean = false;        //PC端调试模式
  static Appmodel: number=3;             //1首次启动  2.今日首次启动 3普通模式启动

  //设备信息
  static deviceId:string = '';          //设备id
  static deviceCordova:string = '';          //设备上运行的Cordova版本
  static deviceModel:string = '';           //设备型号或产品的名称
  static devicePlatform:string = '';          //操作系统名称
  static devicePlatformVersion:string = '';          //操作系统版本
  static deviceManufacturer:string = '';          //设备的制造商
  static deviceSerial:string = '';          //设备硬件序列号

  //APP信息
  static platform:string = '';          // android  ios
  static appName:string = 'CRM_KmfApp';           //CRM_KmfApp
  static appVersion:string = '2.0.2';        //版本号 2.0.2

  //常规配置
  static userProtocol:string = '';      //用户协议


  //用户信息
  static userName:string = '';          //账号名
  static token:string = '';             //token
  // static userInfo: User;             //用户信息

  //授权信息
  static expireDate:any = '2018.01.01';           //APP到期日期

  //极光推送
  static jPushRegistrationId:string='';            //极光的注册id;
  static jPushAlias:string='';                //极光的别名;
  static jPushTags:string='';                //极光的标签;


  //获取设备高度
  public static getWindowHeight() {
    return window.screen.height;
  }

  //获取设备宽度
  public static getWindowWidth() {
    return window.screen.width;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts